module.exports = __webpack_public_path__ + "img/ios-play.02d9f9a4.png";